<div [id]="xCollapseItem.id" class="collapse-item" [ngClass]="{ 'is-open': xCollapseItem.isOpen }">
  <div
    class="container-title c-pointer js-collapse-item-action"
    (click)="toggleItem(xCollapseItem)"
    (keyup.enter)="toggleItem(xCollapseItem)"
    (keyup.space)="toggleItem(xCollapseItem)"
    [attr.tabindex]="0"
  >
    <button type="button">
      <span class="material-symbols-outlined text-common"> arrow_forward_ios </span>
    </button>

    <p class="title preserve-white-spaces">
      {{ xCollapseItem.title }}
      <span *ngIf="xCollapseItem.subTitle" class="sub-title">
        {{ xCollapseItem.subTitle }}
      </span>
    </p>
  </div>

  <hr class="border-secondary" />

  <div class="collapse-content">
    @if (!isHtmlEditable) {
      <div [innerHTML]="xCollapseItem.content"></div>
    } @else {
      <div [innerHTML]="sanitizedContent(xCollapseItem.content)"></div>
    }

    <div class="content-component" [ngClass]="{ 'd-none': !xCollapseItem.component }">
      <ng-template #dynamicContainer></ng-template>
    </div>

    @if (xCollapseItem.cxComponent) {
      <div class="content-flex-component">
        @if (!xCollapseItem.cxComponent.flexType) {
          <p>Component not exist at backoffice or not mapped.</p>
        }

        <ng-template [cxOutlet]="xCollapseItem.cxComponent.flexType">
          <ng-container [cxComponentWrapper]="xCollapseItem.cxComponent"></ng-container>
        </ng-template>
      </div>
    }
  </div>
</div>
